import { useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import { TAG_COLORS } from 'utils/constants/taskTags'
import ButtonColor from './ButtonColor'
import { PaletteWrap, ButtonOpen, PaletteSection } from './styled'

const Palette = forwardRef(
  (
    {
      withBackground = true,
      initialColor = '',
      initialBgColor = '',
      setFieldValue = false,
      onColorChange = false,
      onTouched,
    },
    ref
  ) => {
    const [openPalette, setOpenPalette] = useState(false)
    const [defaultColor, setDefaultColor] = useState(
      initialColor && initialBgColor
        ? { color: initialColor, bg_color: initialBgColor }
        : null
    )

    useImperativeHandle(ref, () => ({
      resetColor: () => {
        setDefaultColor(null)
      },
    }))

    useEffect(() => {
      if (setFieldValue && defaultColor) {
        setFieldValue('color', defaultColor.color)
        setFieldValue('bg_color', defaultColor.bg_color)
      }
    }, [defaultColor])

    const handleButtonColorClick = (textColor, bgColor) => {
      setOpenPalette(false)
      setDefaultColor({ color: textColor, bg_color: bgColor })

      if (onColorChange) {
        onColorChange({ color: textColor, bg_color: bgColor })
      }
    }

    return (
      <PaletteWrap>
        <ButtonOpen
          type="button"
          color={defaultColor?.bg_color ?? null}
          withBackground={withBackground}
          onClick={() => {
            setOpenPalette((prev) => !prev)
            onTouched?.()
          }}
        />
        {openPalette && (
          <PaletteSection withBackground={withBackground}>
            {Array.from(TAG_COLORS.entries()).map(([key, value]) => (
              <ButtonColor
                type="button"
                handleClick={() =>
                  handleButtonColorClick(value.color, value.bg_color)
                }
                key={key}
                textColor={value.color}
                bgColor={value.bg_color}
              >
                A
              </ButtonColor>
            ))}
          </PaletteSection>
        )}
      </PaletteWrap>
    )
  }
)

export default Palette
